import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* position: relative; */
`;

interface IRowDiv {
  isCustomField: boolean;
}

export const RowDiv = styled.div<IRowDiv>`
  display: flex;
  flex-direction: row;
  cursor: ${({ isCustomField }) => (isCustomField ? 'unset' : 'pointer')};
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
`;
export const Tags = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  text-align: left;
  display: flex;
  flex-direction: column;
`;
export const Tbody = styled.tbody`
  display: block;
`;
export const TbodyTag = styled.tbody`
  display: block;
  overflow-y: auto;
  padding: 1px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
export const Trh = styled.tr`
  width: 100%;
  display: flex;
`;
interface TrProps {
  isSelected: boolean;
  first?: boolean;
}
export const Tr = styled.tr<TrProps>`
  position: relative;
  border-radius: 8px;
  background-color: #f5f7fb;

  overflow: hidden;

  margin-bottom: 12px;
  z-index: auto;
  display: flex;
  /* These styles never change. Are they needed?? */
  /* This is  because isSelected is always false. */
  border-color: ${({ isSelected }) =>
    isSelected ? beam.color.primaryBlue : 'transparent'};
  border-width: ${({ isSelected }) => (isSelected ? '1px' : '0')};
  border-style: solid;
  border-color: ${({ first }) => (first ? '#1371fe' : 'transparent')};
  border-width: ${({ first }) => (first ? '1px' : '0')};
`;
interface TdProps {
  isSelected?: boolean;
  widthPercentage: number;
}
export const Td = styled.td<TdProps>`
  width: ${({ widthPercentage }) => widthPercentage}%;
  max-width: ${({ widthPercentage }) => widthPercentage}%;
  padding-bottom: 8px;
  /* border: 1px solid #000; */
  padding-top: 8px;
  position: relative;
  padding-left: 8px;
  overflow: hidden;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-align: start;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 48px;
  max-height: 46px;

  :after {
    content: '';
    width: 40px;
    right: 0;
    position: absolute;
    height: 38px;
    z-index: 4;
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 16px;
  border: 1px solid #d8dae5;
`;
interface IconProps {
  isDesc?: boolean;
}
export const Icon = styled.img<IconProps>`
  width: 8px;
  height: 10px;
  margin-left: 8px;
  transform: ${({ isDesc }) => (isDesc ? 'rotate(-180deg)' : 'rotate(0deg)')};
`;
export const IconEdit = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  cursor: pointer;
`;
export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 16px;
  object-fit: cover;
  margin-right: 16px;
`;

interface IBody {
  widthPercentage: number;
  isActive?: boolean;
}

export const Thead = styled.thead`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 8px;
  border-radius: 8px;
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const Th = styled.th<IBody>`
  display: flex;
  width: ${({ widthPercentage }) => widthPercentage}%;
  border: solid 1px transparent;
  border-style: solid none;
  height: 32px;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 8px;
  align-items: center;
  background: transparent;
  color: #8f95b2;
  position: relative;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    padding-right: 8px;
  }
  :after {
    content: '';
    width: 40px;
    right: 0;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    padding-right: 8px;
    position: absolute;
    height: 30px;
    z-index: 4;
  }
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 14px;
  text-align: center;
`;

export const PageInfo = styled.div`
  border-radius: 8px;
  text-align: center;
  height: 40px;
  padding: 0 20px;
  color: #50525f;
  background: #efefef;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;
export const IconImgAwesome = styled(FontAwesomeIcon)`
  color: ${beam.font.primary};
  width: 14px;
  height: 14px;
  position: absolute;
  right: 16px;
  top: 14px;
  cursor: pointer;
  z-index: 5;
`;

export const TagCount = styled.div`
  border-radius: 15px;
  color: #8f95b2;
  padding: 0 10px;
  height: 24px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  border: none;
  background: #edeff4;
  font-size: 14px;
  font-weight: 500;
  /* identical to box height */
  text-align: center;
  /* beam texts/logo text */
`;

interface ISelectedDiv {
  first: boolean;
}

export const SelectedDiv = styled.div<ISelectedDiv>`
  display: ${({ first }) => (first ? 'flex' : 'none')};
  position: absolute;
  top: 0;
  right: 0;
  background-color: #1371fe;
  align-self: flex-end;
  padding: 0 3px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 0 0 0 8px;
`;

export const TagsWrapper = styled.div`
  width: 100%;
`;
